import trans from './trans';

export function isScrolledIntoView(elem)
{
  let docViewTop = $(window).scrollTop();
  let docViewBottom = docViewTop + $(window).height();

  let headerNavBar = $('.navbar.fixed-top');
  if (headerNavBar.length > 0) {
    docViewTop += headerNavBar.height();
  }

  let elemTop = $(elem).offset().top;
  let elemBottom = elemTop + $(elem).height();

  return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

export function areAllPropertiesEmpty(o) {
  return Object.keys(o).every(function(x) {
    return o[x]===''||o[x]===null;
  });
}

export function getPriceWithCurrency(price) {
  const currencySymbol = window.$jBoard.currency.symbol;
  const template = window.$jBoard.currency.template
    ? window.$jBoard.currency.template
    : window.$jBoard.currency_default_template;

  return template
    .replace(':AMOUNT', tenantNumberFormat(price))
    .replace(':SYMBOL', currencySymbol);
}

export function tenantNumberFormat(number) {
  let jboardNumberFormat = window.$jBoard.number_format;
  return numberFormat(number, jboardNumberFormat.dec, jboardNumberFormat.dec_point, jboardNumberFormat.thousands_sep);
}

// PHP's number_format in JavaScript
export function numberFormat (number, decimals, decPoint, thousandsSep) {
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
  const n = !isFinite(+number) ? 0 : +number
  const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
  const sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
  const dec = (typeof decPoint === 'undefined') ? '.' : decPoint
  let s = ''
  const toFixedFix = function (n, prec) {
    if (('' + n).indexOf('e') === -1) {
      return +(Math.round(n + 'e+' + prec) + 'e-' + prec)
    } else {
      const arr = ('' + n).split('e')
      let sig = ''
      if (+arr[1] + prec > 0) {
        sig = '+'
      }
      return (+(Math.round(+arr[0] + 'e' + sig + (+arr[1] + prec)) + 'e-' + prec)).toFixed(prec)
    }
  }
  // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
  s = (prec ? toFixedFix(n, prec).toString() : '' + Math.round(n)).split('.')
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }
  return s.join(dec)
}

export function getEncodedHtml(htmlContent) {
  const temp = document.createElement("p");
  temp.textContent = htmlContent;
  return temp.innerHTML;
}

export function getFormattedDateWithTranslatedMonth(date) {
  const newDate = new Date();
  newDate.setDate(date);

  const formattedDate = newDate.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  const month = formattedDate.split(" ")[0];
  const translatedMonth = trans('general.date.month.' + month.toLowerCase());

  return formattedDate.replace(month, translatedMonth);
}

export function debounce (func, delay) {
  let timer;
  return function() {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this), delay);
  };
}
